import React from 'react';
import styles from './Services.module.css';

const Services = () => {
  const services = [
    {
      title: "Web Vulnerability Assessment and Security Analysis",
      description: "Comprehensive security assessment of web applications and APIs to identify and remediate vulnerabilities.",
      details: [
        "Automated and manual scanning for XSS, SQL Injection, CSRF, SSRF, and Directory Traversal",
        "Testing for business logic flaws and authentication bypasses",
        "API security analysis and endpoint testing",
        "Detailed remediation recommendations"
      ]
    },
    {
      title: "Vulnerability Management and Patching",
      description: "Proactive security patching strategy to prevent exploitation of known vulnerabilities.",
      details: [
        "Critical security patches for OS, applications, and frameworks",
        "Configuration hardening and security baseline implementation",
        "Regular vulnerability scanning with CVSS-based prioritization",
        "Automated patch management solutions"
      ]
    },
    {
      title: "Server Hardening & Infrastructure Security",
      description: "Comprehensive server and infrastructure protection against internal and external threats.",
      details: [
        "Firewall configuration and access control implementation",
        "IDS/IPS setup for real-time attack mitigation",
        "Network segmentation and security architecture design",
        "Cloud environment security (AWS, Azure, GCP)"
      ]
    },
    {
      title: "Security Operations Center (SOC)",
      description: "24/7 security monitoring and incident response capabilities.",
      details: [
        "Real-time threat detection and analysis",
        "Incident response and forensics",
        "SIEM implementation and log correlation",
        "Compliance monitoring and reporting"
      ]
    },
    {
      title: "Secure Software Development (DevSecOps)",
      description: "Integration of security practices into the software development lifecycle.",
      details: [
        "Source code security review and best practices",
        "Dependency analysis and vulnerability assessment",
        "CI/CD pipeline security integration",
        "Security training for development teams"
      ]
    }
  ];

  return (
    <div className={styles.container} id="services">
      <h1 className={styles.title}>Services</h1>
      <p className={styles.content}>
        Discover my comprehensive range of cybersecurity services, tailored to protect your digital assets and infrastructure.
      </p>
      <div className={styles.servicesList}>
        {services.map((service, index) => (
          <div key={index} className={styles.serviceItem}>
            <h2 className={styles.serviceTitle}>{service.title}</h2>
            <p className={styles.serviceDescription}>{service.description}</p>
            <ul className={styles.serviceDetails}>
              {service.details.map((detail, idx) => (
                <li key={idx}>{detail}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
